import React from 'react';
import styled from 'styled-components';
import { COLOR_DESCRIPTION, COLOR_PRIMARY, COLOR_SECONDARY, DEVICES } from '../../const';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import AddIcon from '@mui/icons-material/Add';
import { useMediaQuery } from '@mui/material';
import DownArrow from '../../assets/down_arrow.png';

const Background = styled.div`
  margin: 100px auto;
  text-align: center;

  @media ${DEVICES.mobile} {
    margin: 0 auto;
    padding: 80px 1.5rem 1.5rem 1.5rem;
  }

  @media ${DEVICES.tablet} {
    padding: 160px 2rem 2rem 2rem;
  }

  @media ${DEVICES.large} {
    max-width: 1200px;
  }
`;

const CatchPhrase = styled.div`
  line-height: 1.3;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25rem;
  }
`;

const CatchPhraseBold = styled.div`
  font-weight: 700;
  line-height: 1.3;

  @media ${DEVICES.mobile} {
    font-size: 2rem;
    margin-top: 1rem;
  }

  @media ${DEVICES.tablet} {
    font-size: 1.5rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 2.25rem;
  }
`;

const IconWrapper = styled.div`
  @media ${DEVICES.mobile} {
    font-size: 32px;
  }

  @media ${DEVICES.tablet} {
    font-size: 48px;
  }

  @media ${DEVICES.laptop} {
    font-size: 60px;
  }
`;

const Description = styled.div`

  @media ${DEVICES.mobile} {
    font-size: 1em;
  }

  @media ${DEVICES.tablet} {
    font-size: 1rem;
  }

  @media ${DEVICES.laptop} {
    font-size: 1rem;
  }
`;

const PainList = styled.div`

  justify-content: center;
  min-height: 150px;

  @media ${DEVICES.mobile} {
  }

  @media ${DEVICES.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1.5rem;
    margin-top: 80px;
  }

  @media ${DEVICES.laptop} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 1.5rem;
  }
`;

const PainItem = styled.div`
  background-color: #fff;
  padding: 2rem;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  border-radius: 1rem;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);

  @media ${DEVICES.mobile} {
    margin-top: 1.5rem;
  }

  @media ${DEVICES.tablet} {
    margin-top: 0;
  }

  @media ${DEVICES.laptop} {
    margin-top: 0;
  }
`;

const PainItemTitle = styled.div`
  font-weight: 700;
  margin: 0 0 1.3rem 0;
  color: #ED4342;
`;

const PainItemDescription = styled.div`
  color: ${COLOR_DESCRIPTION};
`;

const DownArrowImg = styled.img`
  margin: 60px 0;
`;

const SolutionItem = styled.div`
  background-color: ${COLOR_PRIMARY};
  padding: 3rem 2rem;
  text-align: center;
  min-height: 100%;
  box-sizing: border-box;
  border-radius: 1rem;
  width: 100%;
  box-shadow: 1px 25px 57px -25px rgb(0 0 0 / 20%);

  @media ${DEVICES.mobile} {
    margin: 0 0 1.5rem 0;
  }

  @media ${DEVICES.tablet} {
    margin: 0 0 1.5rem 0;
  }

  @media ${DEVICES.laptop} {
    margin: 0 0 1.5rem 0;
  }
`;

const SolutionItemTitle = styled.div`
  font-weight: 700;
  font-size: 1.5rem;
`;

const SolutionItemDescription = styled.div`
  margin-top: 2rem;
  font-weight: 500;
  @media ${DEVICES.mobile} {
    font-size: 1rem;
  }
  
  @media ${DEVICES.tablet} {
    font-size: 1.2rem;
  }
`;

const SolutionIconWrapper = styled.div`
  color: #fff;
  margin-top: 0.3rem;
`;

export default function PainBanner() {

  const overTablet = useMediaQuery(`${DEVICES.tablet}`);

  const descriptionTemplate = () => {
    if (overTablet) {
      return <div>
        주입식 운동이 아닌, 아이들 스스로 깨닫는 운동!<br />
        어린 아이들에게 단연코 운동만큼 좋은 습관은 없습니다
      </div>
    } else {
      return <div>
        주입식 운동이 아닌, <br />
        아이들 스스로 깨닫는 운동! <br />
        어린 아이들에게 단연코 운동만큼 <br />
        좋은 습관은 없습니다
      </div>
    }
  };
  return <Background>
    <CatchPhrase>
      피드백 없는 체육 학원은 이제 그만
    </CatchPhrase>
    <CatchPhraseBold>
      유소년기부터 시작하는 과학적인 체력관리
    </CatchPhraseBold>
    <IconWrapper>
      <HorizontalRuleOutlinedIcon color="primary" fontSize='inherit' />
    </IconWrapper>
    <Description>
      {descriptionTemplate()}
    </Description>
    <PainList>
      <PainItem>
        <PainItemTitle>
          디지털 빌런
        </PainItemTitle>
        <PainItemDescription>
          "디지털과부화, 디지털치매,<br />
          디지털 집중방해 속에서 살고 있는 아이들"
        </PainItemDescription>
      </PainItem>
      <PainItem>
        <PainItemTitle>
          높은 강사 의존도
        </PainItemTitle>
        <PainItemDescription>
          “아이들을 새롭게 마주할 때<br />
          경험적 데이터에만 의존해야 하는 선생님들”
        </PainItemDescription>
      </PainItem>
      <PainItem>
        <PainItemTitle>
          피드백이 없는 교육
        </PainItemTitle>
        <PainItemDescription>
          “아이들이 즐겁게 다니고 있지만 <br />
          마음 한 켠 불안감이 존재하는 학부모님들”
        </PainItemDescription>
      </PainItem>
    </PainList>
    <DownArrowImg src={DownArrow} />
    <SolutionItem>
      <SolutionItemTitle>
        SOLUTION
      </SolutionItemTitle>
      <SolutionItemDescription>
        어린아이들에게 필요한 기능성 운동 <br />
        <SolutionIconWrapper>
          <AddIcon color='inherit' fontSize='small' />
        </SolutionIconWrapper>
        데이터 기반의 학생 관리 <br />
        <SolutionIconWrapper>
          <AddIcon color='inherit' fontSize='small' />
        </SolutionIconWrapper>
        객관적인 피드백 제공
      </SolutionItemDescription>
    </SolutionItem>
  </Background>
}
